import 'url-search-params-polyfill';

export default function resolveCardDesignFromUrl() {
  let queryParams = new URLSearchParams(document.location.search.substring(1));
  let cardDesignId = queryParams.get("cardDesignId");
  return cardDesignId ? cardDesignId : null;
}

